import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      meta: {
        title: '首页'
      },
      component: resolve => {
        require(['@/views/home/index.vue'], resolve)
      }
    },
    {
      path: '/risk',
      name: 'risk',
      meta: {
        title: '大数据风控'
      },
      component: resolve => {
        require(['@/views/risk/index.vue'], resolve)
      }
    },
    {
      path: '/contact',
      name: 'contact',
      meta: {
        title: '联系方式'
      },
      component: resolve => {
        require(['@/views/contact/index.vue'], resolve)
      }
    },
    {
      path: '/saas',
      name: 'saas',
      meta: {
        title: 'saas服务'
      },
      component: resolve => {
        require(['@/views/saas/index.vue'], resolve)
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js